export class Additionals {

  public static readonly ALL = new Additionals({addAll: true});
  public static readonly NONE = new Additionals();

  public addAll: boolean = false;
  public addEmails: boolean = false;
  public addPhones: boolean = false;
  public addAddresses: boolean = false;
  public addBankAddresses: boolean = false;
  public addOccurrences: boolean = false;
  public addHyperlinks: boolean = false;
  public addSettings: boolean = false;
  public addPermissions: boolean = false;
  public addPositions: boolean = false;
  public addUser: boolean = false;
  public addGroup: boolean = false;
  public addFeature: boolean = false;
  public addPayment: boolean = false;
  public addComment: boolean = false;

  constructor(init?: Partial<Additionals> | undefined) {
    Object.assign(this, init);
  }

  public asArray(): string[] {
    const res: string[] = [];
    if (this.addAll) {
      res.push('addAll');
    }
    if (this.addEmails) {
      res.push('addEmails');
    }
    if (this.addPhones) {
      res.push('addPhones');
    }
    if (this.addAddresses) {
      res.push('addAddresses');
    }
    if (this.addBankAddresses) {
      res.push('addBankAddresses');
    }
    if (this.addOccurrences) {
      res.push('addOccurrences');
    }
    if (this.addHyperlinks) {
      res.push('addHyperlinks');
    }
    if (this.addSettings) {
      res.push('addSettings');
    }
    if (this.addPermissions) {
      res.push('addPermissions');
    }
    if (this.addPositions) {
      res.push('addPositions');
    }
    if (this.addUser) {
      res.push('addUser');
    }
    if (this.addGroup) {
      res.push('addGroup');
    }
    if (this.addFeature) {
      res.push('addFeature');
    }
    if (this.addPayment) {
      res.push('addPayment');
    }
    if (this.addComment) {
      res.push('addComment');
    }
    return res;
  }
}
